import React, { Component } from "react";
import { getProceduresOrderByDate, getProcedureTagNames, getTags } from "../../../service/procedures";
import DataTableComponent from '../core/DataTableComponent';
import { getDateFormatted } from "../../../service/functions";
import { LANGUAGE_NAMES } from "../../../service/constants";
import { createEnlaceUrl, LINK_TYPES } from "../../../service/enlaces";
import QRCode from 'qrcode';

class ProcedureComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            procedures: []
        };
    }

    componentDidMount = () => {
        this.getInitialData()
    }
    getInitialData = async () => {
        let procedures = await getProceduresOrderByDate()
        let tags = await getTags()
        this.setState({ procedures, tags });
    }

    getColumns = () => [
        { label: 'Fecha de creación', field: 'date', sort: 'asc' },
        { label: 'Nombre', field: 'name', sort: 'asc' },
        { label: 'Tipo de usuario', field: 'type', sort: 'asc' },
        { label: 'Especie', field: 'kynd', sort: 'asc' },
        { label: 'Etiquetas', field: 'tags', sort: 'asc' },
        { label: 'Idiomas', field: 'translationLanguages', sort: 'asc' },
        { label: 'QR', field: 'qr', sort: 'asc' }
    ];
    downloadQRCode = async (procedureId, procedureName, event) => {
        event.stopPropagation();
        
        try {
            const enlaceUrl = createEnlaceUrl(LINK_TYPES.PROCEDURE, procedureId);
            const dataUrl = await QRCode.toDataURL(enlaceUrl, {
                width: 300,
                margin: 2
            });
            
            const link = document.createElement('a');
            const snakeCaseName = procedureName.toLowerCase().replace(/ /g, '-');
            link.download = `qr-cirugía-${snakeCaseName}.png`;
            link.href = dataUrl;
            link.click();
        } catch (error) {
            console.error('Error al generar QR:', error);
            window.alert('Error al generar el código QR. Por favor, intenta de nuevo.');
        }
    }

    getProceduresData = () => {
        let rows = this.state.procedures.map(procedure => ({
            date: getDateFormatted(procedure.date),
            name: procedure.name,
            type: procedure.type,
            kynd: procedure.kynd,
            tags: getProcedureTagNames(procedure, this.state.tags),
            translationLanguages: Array.isArray(procedure.translationLanguages) 
                ? (procedure.translationLanguages.length >= 4
                    ? procedure.translationLanguages.slice(0, 2).map(lang => LANGUAGE_NAMES[lang]).join(', ') + `, +${procedure.translationLanguages.length - 2}`
                    : procedure.translationLanguages.map(lang => LANGUAGE_NAMES[lang]).join(', '))
                : 'Español',
            qr: <button 
                type="button" 
                className="btn btn-sm btn-primary" 
                onClick={(e) => this.downloadQRCode(procedure.id, procedure.name, e)}
            >
                Descargar QR
            </button>,
            clickEvent: (event) => this.props.history.push(`/admin/procedures/procedure/${procedure.id}`)
        }));
        return { columns: this.getColumns(), rows };
    }

    render() {
        return (
            <div className="content-wrapper p-5">
                <div className="row">
                    <div className="col-md-12">
                        <h1>Cirugías</h1>
                        <DataTableComponent data={this.getProceduresData()} />
                        <div className="btn-row"  >
                            <a role="button" href="/admin/tags/" className="btn btn-primary">Administrar etiquetas</a>
                            <a role="button" href="/admin/procedures/procedure" className="btn btn-primary">Crear nueva cirugía</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
export default ProcedureComponent;